// XXX use let instead of import because of siteadmin hack below
let $ = require<JQueryStatic>('jquery');

// HACK: siteadmin iframe context
declare var process: any;
declare var diy: any;
if (top !== window && typeof process === 'undefined') {
    $ = diy.editor.jQuery;
}

const $document = $(document);
/**
 * @class diy.util.globalEvents
 * @template diy.util.globalEvents
 * @type {{trigger: Function, on: Function}}
 */
export = {
    trigger: function(eventName: string, payload?: any) {
        $document.trigger(eventName, payload);
    },
    one: function(eventName: string, handler: (eventObject: JQueryEventObject) => any) {
        $document.one(eventName, handler);
    },
    on: function(eventName: string, handler: (eventObject: JQueryEventObject) => any) {
        $document.bind(eventName, handler);
    },
    off: function(eventName: string, handler: (eventObject: JQueryEventObject) => any) {
        $document.unbind(eventName, handler);
    }
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/globalEvents.ts
 **/